module.exports = __webpack_public_path__ + "img/logo-isotype.9873ffc.png";